<template>
  <div class="user-profile" @click.stop="clickUserName">
    <span :class="nickNameClass" class="nickname"> {{ itemData.owner.nickname }}</span>
    <span :class="tagClass" />
    <span :class="tagMeClass" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, toRefs } from 'vue';
import { useGlobalState } from '@cpc/comment-sdk-core-comment';

import { commonCommentStat } from '../core/useStat';

export default defineComponent({
  name: 'UserProfile',

  components: {},

  props: {
    itemData: {
      type: Object,
      default() {
        return {};
      },
    },

    parentOwner: {
      type: Object,
      default() {
        return {};
      },
    },

    showTagPoster: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const { showTagPoster, parentOwner, itemData } = toRefs(props);

    const { userMeta } = toRefs(useGlobalState());

    const tagClass = computed(() => {
      const secondCommentDetail = showTagPoster.value
        ? {
            'tag-poster': parentOwner.value.id === itemData.value.owner.id,
          }
        : {};

      return {
        'tag': true,
        'tag-top': itemData.value.tag === 'TOP',
        'tag-good': itemData.value.tag === 'GOOD',
        'tag-god': itemData.value.tag === 'GOD',
        'tag-hot': itemData.value.tag === 'HOT',
        ...secondCommentDetail,
      };
    });

    const nickNameClass = computed(() => {
      return showTagPoster.value ? 'second-detail-nickName' : 'common-nick-name';
    });

    const tagMeClass = computed(() => {
      return {
        'tag': true,
        'tag-me': userMeta.value.uid === itemData.value.owner.id,
      };
    });

    const clickUserName = () => {
      commonCommentStat(20084691, {
        userId: itemData.value.id,
      });
    };

    return {
      tagClass,
      tagMeClass,
      clickUserName,
      nickNameClass,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '../assets/css/styling-mixin.scss';

.user-profile {
  display: flex;
  align-items: center;
  min-width: 0; // fix flex & ellipsis
}

.second-detail-nickName {
  font-size: 42px;
  font-weight: 500;
  color: rgba($color: #000, $alpha: 0.9);
  @include os-browser-styling('', '', false, false, true, true) {
    color: rgba($color: #fff, $alpha: 0.9);
  }
}

.common-nick-name {
  font-size: 36px;
  line-height: 48px;
  font-weight: 400;
  color: rgba($color: #000, $alpha: 0.54);
  @include os-browser-styling('', '', false, false, true, true) {
    color: rgba($color: #fff, $alpha: 0.54);
  }
}

.nickname {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tag {
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 12px;

  &-top,
  &-good,
  &-god,
  &-hot,
  &-poster {
    margin-left: 18px;
    width: 78px;
    height: 42px;
  }

  &-me {
    margin-left: 18px;
    width: 42px;
    height: 42px;
    background-image: url(../assets/img/tag/tag-me.png);
  }

  &-hot {
    background-image: url(../assets/img/tag/tag-hot.png);
  }
  &-top {
    background-image: url(../assets/img/tag/tag-top.png);
  }
  &-good {
    background-image: url(../assets/img/tag/tag-good.png);
  }
  &-god {
    background-image: url(../assets/img/tag/tag-god.png);
  }
  &-poster {
    background-image: url(../assets/img/tag/tag-poster.png);
  }
}

html[data-theme='dark'] {
  .tag {
    &-me {
      background-image: url(../assets/img/tag/tag-me-dark.png);
    }
    &-hot {
      background-image: url(../assets/img/tag/tag-hot-dark.png);
    }
    &-top {
      background-image: url(../assets/img/tag/tag-top-dark.png);
    }
    &-good {
      background-image: url(../assets/img/tag/tag-good-dark.png);
    }
    &-god {
      background-image: url(../assets/img/tag/tag-god-dark.png);
    }
    &-poster {
      background-image: url(../assets/img/tag/tag-poster-dark.png);
    }
  }
}
</style>
